export const GUTTER = 12;
export const MIN_FREE_PX = 80;            // degenerate guard only (see fitPaddings)
export const EMPTY_INSETS = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };

// fitBounds options for "fit into the free rectangle". `size` = map.getSize() ({x,y}). The paddings are the
// REAL occlusion (no scaling). Only when a free side would be < MIN_FREE_PX (a layout this plan never produces)
// are both paddings of that axis scaled so Leaflet never fits into a negative rectangle; `degenerate` reports it.
export function fitPaddings(insets, size, gutter = GUTTER) {
  let top = gutter + (insets.top || 0);
  let bottom = gutter + (insets.bottom || 0);
  let left = gutter + (insets.left || 0);
  let right = gutter + (insets.right || 0);
  let degenerate = false;
  if (size) {
    if (size.y - top - bottom < MIN_FREE_PX && top + bottom > 0) {
      degenerate = true;
      const k = Math.max(0, size.y - MIN_FREE_PX) / (top + bottom);
      top = Math.floor(top * k);
      bottom = Math.floor(bottom * k);
    }
    if (size.x - left - right < MIN_FREE_PX && left + right > 0) {
      degenerate = true;
      const k = Math.max(0, size.x - MIN_FREE_PX) / (left + right);
      left = Math.floor(left * k);
      right = Math.floor(right * k);
    }
  }
  return { paddingTopLeft: [left, top], paddingBottomRight: [right, bottom], maxZoom: 8, animate: true, degenerate };
}

export const layoutKey = (i) => `${i.top}|${i.right}|${i.bottom}|${i.left}|${i.width}|${i.height}`;
